import MessageBubble from './MessageBubble';
import { profilingAgentApi } from '../../../services/api';
import type { AgentSpec } from '../../agents/shared/types';

/**
 * Profiling Agent, migrated onto the shared AgentConversation /
 * AgentLanding. Behaviour is byte-identical to the old self-contained
 * page — the rich Reltio MessageBubble (with all its blocks) is reused
 * AS-IS via this spec. Copy/constants preserved verbatim.
 */
export const profilingAgentSpec: AgentSpec = {
  title: 'Profiling Agent',
  subtitle:
    'QA Analyst for onboarding. Profile source tables, generate a '
    + 'dictionary, suggest data-quality rules, map source to target, '
    + 'and create the project.',
  heroHeading: 'Pre-load data quality check in chat',
  heroDescription:
    'The Profiling Agent samples your table, proposes a validation '
    + 'schema, runs a pushdown quality assessment, and returns a '
    + 'prioritized cleanup playbook with runnable SQL — all '
    + 'conversationally. The rules it deploys become your ongoing '
    + 'monitors.',
  placeholder: 'Ask the agent — profile a table for pre-load quality assessment...',

  backRoute: '/source-profiling/agent',
  sessionRouteBase: '/source-profiling/agent/sessions',
  queryKeyPrefix: 'profiling-agent',
  streamUrlBase: '/api/profiling-agent',

  api: profilingAgentApi,

  MessageBubble,
  detailCardTools: ['read_table_for_profiling', 'propose_schema_labels', 'run_quality_assessment'],

  samplePrompts: [
    {
      label: 'profile ASSURE_DEMO.CUSTOMER_PROFILES using test credentials',
      prompt: 'profile ASSURE_DEMO.CUSTOMER_PROFILES using test credentials',
      help: 'ASSURE_DEMO.CUSTOMER_PROFILES is SCHEMA.TABLE (ASSURE_DEMO = schema, CUSTOMER_PROFILES = table — use yours). "test credentials" = pre-set demo connection. It runs an exact whole-table pushdown profile and proposes a validation schema (types, patterns, rules).',
    },
    {
      label: 'check data quality for DEMO_TGT.DIM_PARTY using test credentials',
      prompt: 'check data quality for DEMO_TGT.DIM_PARTY using test credentials',
      help: 'DEMO_TGT.DIM_PARTY is SCHEMA.TABLE (DEMO_TGT = schema, DIM_PARTY = table — use yours). "test credentials" = pre-set demo connection. It profiles the table, then runs a scored pushdown quality assessment (completeness, uniqueness, format checks).',
    },
  ],
};
